import { render, staticRenderFns } from "./Problematic.vue?vue&type=template&id=ce90a0b6&scoped=true&"
import script from "./Problematic.vue?vue&type=script&lang=js&"
export * from "./Problematic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce90a0b6",
  null
  
)

export default component.exports